import yup from 'yup';

const schema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, 'Must be longer than 1 character')
    .required('Terminal Name is required'),
});

export default schema;
